// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.2',
  revision: 'f4f6d3b60',
  branch: 'master',
  date: 'Thu, 09 Jul 2026 13:42:45 GMT'
};